import { AfterViewChecked, Directive, Input } from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appOwlCarousel]'
})
export class OwlCarouselDirective implements AfterViewChecked {
    @Input() headerData: any;
    @Input() autoRotate: boolean;

    constructor() {
    }

    ngAfterViewChecked() {
        if (this.headerData && this.headerData.length > 0) {
            if (this.autoRotate) {
                $('.offer_slider').owlCarousel({
                    loop: false,
                    margin: 0,
                    items: 1,
                    nav: false,
                    dots: false,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    stagePadding: 20
                });
            } else {
                $('.offer_slider').owlCarousel({
                    loop: false,
                    margin: 0,
                    items: 1,
                    nav: false,
                    dots: false,
                    stagePadding: 20
                });
            }
            $('.notification').owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                items: 1,
                dots: true,
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true
            });
            $('.switchteam_slider').owlCarousel({
                loop: false,
                margin: 0,
                items: 1,
                nav: false,
                dots: false,
                stagePadding: 15,
                responsiveClass: true,
                responsive: {
                    0: {
                        stagePadding: 8,
                    },
                    451: {
                        stagePadding: 15,
                    }
                }
            });
        }
        $('.landing_slider').owlCarousel({
            loop: false,
            margin: 0,
            nav: false,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
        });
    }
}
